"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = More;

var _react = _interopRequireDefault(require("react"));

function More() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "4px",
    height: "13px",
    viewBox: "0 0 4 13",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-10.000000, -6.000000)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "24",
    height: "24",
    rx: "12"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,10.7211982 C12.8291667,10.7211982 13.5,11.3889401 13.5,12.2142857 C13.5,13.0396313 12.8291667,13.7073733 12,13.7073733 C11.1708333,13.7073733 10.5,13.0396313 10.5,12.2142857 C10.5,11.3889401 11.1708333,10.7211982 12,10.7211982 Z M10.5,7.49308756 C10.5,6.66774194 11.1708333,6 12,6 C12.8291667,6 13.5,6.66774194 13.5,7.49308756 C13.5,8.31843318 12.8291667,8.98617512 12,8.98617512 C11.1708333,8.98617512 10.5,8.31843318 10.5,7.49308756 Z M10.5,16.9354839 C10.5,16.1101382 11.1708333,15.4423963 12,15.4423963 C12.8291667,15.4423963 13.5,16.1101382 13.5,16.9354839 C13.5,17.7608295 12.8291667,18.4285714 12,18.4285714 C11.1708333,18.4285714 10.5,17.7608295 10.5,16.9354839 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}